import { CustomValidatorsFactory } from 'src/app/base/shared/validators/custom-validators-factory';
import { ToastService } from 'src/app/base/services/toast.service';
import { homeRoute } from './../../core/routing/route-names';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserInfoDTO, UpdateUserInfoDTO, UserAccountClient, ClientDTO, Role } from './../models/models.swagger.generated';
import { AuthService } from './../services/auth.service';
import { Component, OnInit } from '@angular/core';
import { TitleBarComponent } from '../shared/title-bar/title-bar.component';
import { UserEditFormComponent } from '../user-edit-form/user-edit-form.component';
import { TranslateModule } from '@ngx-translate/core';
import { UserEditFormType } from '../user-edit-form/user-edit-form-type';
import { passwordValidation } from 'src/app/directives/password-validation.directive';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-edit-profile',
    templateUrl: './edit-profile.component.html',
    styleUrls: ['./edit-profile.component.scss'],
    imports: [TitleBarComponent, UserEditFormComponent, TranslateModule]
})
export class EditProfileComponent implements OnInit {

  public userInfo: UserInfoDTO;
  public userEditForm: FormGroup<UserEditFormType>;

  constructor(private authService: AuthService,
              private userAccountClient: UserAccountClient,
              private toastService: ToastService,
              private router: Router,
              private fb: FormBuilder) {
  }

  public ngOnInit(): void {
    this.userInfo = this.authService.getUserInfo();

    const client = this.authService.getUserInfo().client ? this.authService.getUserInfo().client : this.userInfo.client;
    this.userEditForm = this.fb.group<UserEditFormType>({
      userId: this.fb.control<string>({value: this.userInfo.userId, disabled: true}),
      firstname: this.fb.control<string>({value: this.userInfo.firstname, disabled: true}, [Validators.required]),
      lastname: this.fb.control<string>({value: this.userInfo.lastname, disabled: true}, [Validators.required]),
      language: this.fb.control<string>({value: this.userInfo.language, disabled: true}, [Validators.required]),
      email: this.fb.control<string>({value: this.userInfo.email, disabled: true}, [Validators.required, Validators.email]),
      phoneNumber: this.fb.control<string>({value: this.userInfo.phoneNumber, disabled: true}, [CustomValidatorsFactory.createPhoneValidator()]),
      enabled: this.fb.control<boolean>(this.userInfo.enabled ?? false),
      client: this.fb.control<ClientDTO>({ value: client, disabled: true }, [Validators.required]),
      roles: this.fb.control<Role[]>({value: !!this.userInfo.roles?.length ? this.userInfo.roles : [], disabled: true}),
      userName: this.fb.control<string>({value: this.userInfo.userName, disabled: true}, [Validators.required, CustomValidatorsFactory.createNoDomainUserValidation(), CustomValidatorsFactory.createNoWhiteSpacesAllowed()]),
      password: this.fb.control<string>({value: this.userInfo.password, disabled: true}, [Validators.required, passwordValidation(), CustomValidatorsFactory.createNoWhiteSpacesAllowed()])
    });
  }

  public save(): void {
    if (this.userEditForm.valid) {
      this.updateUser(this.mapToUpdateUserInfoDTO())
        .subscribe({next: () => {
          this.authService.loadUserInfoDTO();
          this.toastService.showSuccess(
            'i18n.base.edit-profile.messages.update.success-title',
            'i18n.base.edit-profile.messages.update.success-message');
          this.router.navigate([homeRoute]);

        }, error: () => {
          this.toastService.showError(
            'i18n.base.edit-profile.messages.update.fail-title',
            'i18n.base.edit-profile.messages.update.fail-message');
        }});
    }

  }

  private updateUser(dto: UpdateUserInfoDTO): Observable<UserInfoDTO> {
    if (dto.roles.includes(Role.AssetStorageGroupMember)){
      return this.userAccountClient.updateAssetStorageGroupMemberUser(dto);
    }
    return this.userAccountClient.updateUser(dto);
  }

  private mapToUpdateUserInfoDTO(): UpdateUserInfoDTO {
    var formData = this.userEditForm.getRawValue();
    const dto = new UpdateUserInfoDTO();
    dto.userId = formData.userId;
    dto.clientId = formData.client?.id;
    dto.email = formData.email;
    dto.enabled = formData.enabled;
    dto.firstname = formData.firstname;
    dto.lastname = formData.lastname;
    dto.language = formData.language;
    dto.phoneNumber = formData.phoneNumber;
    dto.roles = formData.roles != null ? formData.roles : null;

    return dto;
  }
}
